import { CompanyTeamsSortingOption } from '@vyce/core/src/api/types';
import { COMPANY_PERMISSIONS, TabItem, TEAMS_PERMISSIONS } from '@vyce/core/src/types';

export const DEFAULT_TEAMS_LIST_SORTING = {
  field_name: 'name' as CompanyTeamsSortingOption,
  desc: true,
};

export const TEAMS_TABS: TabItem[] = [
  {
    label: 'Dashboard',
    link: '/teams/dashboard',
  },
  {
    label: 'Team Members',
    link: '/teams/members',
  },
  {
    label: 'Pending Invites',
    link: '/teams/pending-invites',
  },
  {
    label: 'Teams',
    link: '/teams/list',
  },
  {
    label: 'Reports',
    link: '/teams/reports',
    permission: TEAMS_PERMISSIONS.CAN_GENERATE_REPORTS,
  },
  {
    label: 'Settings',
    link: '/teams/settings',
    permission: COMPANY_PERMISSIONS.CAN_EDIT,
  },
];
